// extracted by mini-css-extract-plugin
export default {"section":"styles_section__VnqJK","container":"styles_container__CVuu9","tableContainerRow":"styles_tableContainerRow__YCCsJ","tableContainerCol":"styles_tableContainerCol__gYl0B"};